import { Navigate, useParams, useSearchParams } from "react-router-dom";

import {
  careerPlanCompetencyIdFromSearch,
  careerProfileExperienceIndexAssessmentHref,
  careerProfileExperienceIndexHref
} from "../careerPlanLatest";

export default function CareerProfileLegacyExperienceIndexAssessmentRedirect() {
  const { pgaId, day } = useParams();
  const [searchParams] = useSearchParams();

  if (!pgaId) return null;

  if (day === "experience-index") {
    const competencyId = careerPlanCompetencyIdFromSearch(searchParams);
    if (competencyId) {
      return <Navigate to={careerProfileExperienceIndexAssessmentHref(pgaId, competencyId)} replace />;
    }
    return <Navigate to={careerProfileExperienceIndexHref(pgaId)} replace />;
  }

  return <Navigate to={`/people/${pgaId}/career/career-profile/${day}`} replace />;
}
